import api from "../axios";

export const CustomerLogout = async () => {
  const data = api.post("/customer/logout");
  return data;
};
